import { render, staticRenderFns } from "./invoice-wait.vue?vue&type=template&id=1b647e60&scoped=true&"
import script from "./invoice-wait.vue?vue&type=script&lang=js&"
export * from "./invoice-wait.vue?vue&type=script&lang=js&"
import style0 from "./invoice-wait.vue?vue&type=style&index=0&id=1b647e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b647e60",
  null
  
)

export default component.exports